





































































import Vue from "vue";
import FormSection from "@/components/FormSection.vue";
import IconButton from "@/components/IconButton.vue";
import { Flag } from "@/models/GlobalStore";
import store from "../services/GpartsEditStore";
import GpartOtherCostType, { OcostGpartOption, getFlags } from "../models/GpartOtherCostType";

export default Vue.extend({
  components: { 
    FormSection, 
    IconButton 
  },
  data() {
    return { store };
  },
  methods: {
    optionItems(row: GpartOtherCostType) {
      const none = {
        id: 1,
        text: "-",
        isCarSale: false,
        isPostCalc: false,
        isCarRectItem: false,
        isNewPostCalcType: false,
        isShcPostCalcType: false,
        isStockPostCalcType: false,
      };
      return [
        none,
        ...row.options.map((o) => ({
          ...o,
          text: `(Bejövő fksz: ${o.accCodeIn}, Kimenő fksz: ${o.accCodeOut}) ${o.name}`,
        })),
      ];
    },
    optionFlags(option: OcostGpartOption): Flag[] {
      return getFlags(option);
    },
    openGpart(id: number) {
      if (id <= 1) return;
      const route = this.$router.resolve({ name: "GpartEditor2", params: { partsID: String(id) } });
      window.open(route.href, "_blank");
    },
  },
});
